export const SHOW_LOW_CALL_VOLUME_REMINDER = 'SHOW_LOW_CALL_VOLUME_REMINDER';
export const DISMISS_LOW_CALL_VOLUME_REMINDER = 'DISMISS_LOW_CALL_VOLUME_REMINDER';
